import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react"; // Import useState

const navigation = [
  { name: "Home", href: "#", current: true },
  { name: "About", href: "#About", current: false },
  //{ name: "Events", href: "#", current: false },
  { name: "Tracks", href: "#tracks", current: false },
  { name: "Contact", href: "#Contact", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  const [currentItem, setCurrentItem] = useState(navigation[0]); // Initialize current item state

  const handleClick = (item) => {
    setCurrentItem(item);
  };

  return (
    <Disclosure as="nav" className="fixed w-screen z-50 bg-[#0c0d0d]">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 relative">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-[#E9441D] hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex space-x-7  flex-shrink-0 items-center">
                  <img
                    className="h-10 w-auto"
                    src={"./ias-png-white.png"}
                    alt="Your Company"
                  />
                  <img
                    className="h-10 w-auto"
                    src={"./Logo.png"}
                    alt="Your Company"
                  />
            
                </div>
                <div className="hidden pl-40 sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    <div className="flex items-center space-x-7">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className={classNames(
                            item === currentItem
                              ? "bg-[#0c0d0d] text-[#E9441D]"
                              : "text-gray-300 hover:text-[#E9441D]",
                            "rounded-md px-3 py-2 text-sm font-medium"
                          )}
                          onClick={() => handleClick(item)}
                          aria-current={item === currentItem ? "page" : undefined}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`sm:hidden ${open ? 'block' : 'hidden'}`}>
            <div className="space-y-1 bg-[#0c0d0d] w-screen text-center absolute px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item === currentItem
                      ? "text-[#E9441D]"
                      : "text-gray-300 hover-bg-gray-700 hover-text-white",
                    "block rounded-md px-3 py-2 text-base font-medium"
                  )}
                  onClick={() => handleClick(item)}
                  aria-current={item === currentItem ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}
